export const UPDATE_PREFERRED_BILLING = 'UPDATE_PREFERRED_BILLING';

export const submitPreferredBillingInfo = formValues => {
  return {
    type: UPDATE_PREFERRED_BILLING,
    payload: formValues,
  };
};
